// ./src/components/features/Events/rsvpStatusOptions.ts
//
// Every RSVP status a host can filter or count by, with the words the dashboard uses for it. Pure (no React), so the
// report helpers and the guards can read it.
export const RSVP_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'unknown', label: 'Not invited' },
  { value: 'invited', label: 'Invited (no reply yet)' },
  { value: 'visited', label: 'Viewed (no reply)' },
  { value: 'pending', label: 'Pending approval' },
  { value: 'approved', label: 'Attending' },
  { value: 'maybe', label: 'Maybe' },
  { value: 'declined', label: 'Not attending' },
  { value: 'denied', label: 'Declined by host' },
  { value: 'waitlisted', label: 'Waitlisted' },
  { value: 'canceled', label: 'Canceled' },
];
